document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.banner__categories');
    if (!container) return; // Если контейнер отсутствует — выходим

    const wrapper = container.querySelector('.banner__categories-wrapper');
    if (!wrapper) return; // Если обертка отсутствует — выходим

    function checkSwiperNeeded() {
        const containerWidth = container.offsetWidth;
        const wrapperWidth = wrapper.scrollWidth;
        const totalGap = (wrapper.children.length - 1) * 80;
        const needsSwiper = (wrapperWidth + totalGap) > containerWidth;
        return needsSwiper;
    }

    function initSwiperIfNeeded() {
        if (checkSwiperNeeded() && !container.classList.contains('swiper-initialized')) {
            new Swiper(container, {
                slidesPerView: 4,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // pagination: {
                //     el: '.banner__categories-pagination',
                //     clickable: true
                // },
                breakpoints: {
                    1024: {
                        slidesPerView: 'auto',
                        spaceBetween: 80,
                    },
                },
            });
        }
    }

    initSwiperIfNeeded();
    window.addEventListener('resize', initSwiperIfNeeded);
});


document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.products__slider', {
        speed: 800,
        spaceBetween: 20,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },

        pagination: {
            el: '.products__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.products__button-next',
            prevEl: '.products__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3.2,
                spaceBetween: 20,
            },
        },

    });
});

document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.sale__slider', {
        speed: 800,
        spaceBetween: 20,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },

        pagination: {
            el: '.sale__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.sale__button-next',
            prevEl: '.sale__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
        },
    });
});



document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.category-watch__slider', {
        speed: 800,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        spaceBetween: 20,

        pagination: {
            el: '.category-watch__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.category-watch__button-next',
            prevEl: '.category-watch__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
        },
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.category-headphones__slider', {
        speed: 800,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        spaceBetween: 20,

        pagination: {
            el: '.category-headphones__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.category-headphones__button-next',
            prevEl: '.category-headphones__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
        },
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.category-dyson__slider', {
        speed: 800,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        spaceBetween: 20,

        pagination: {
            el: '.category-headphones__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.category-dyson__button-next',
            prevEl: '.category-dyson__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
        },
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.category-accessories__slider', {
        speed: 800,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        spaceBetween: 20,

        pagination: {
            el: '.category-accessories__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.category-accessories__button-next',
            prevEl: '.category-accessories__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
        },
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.category-charge__slider', {
        speed: 800,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        spaceBetween: 20,

        pagination: {
            el: '.category-accessories__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.category-accessories__button-next',
            prevEl: '.category-accessories__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
        },
    });
});



document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.category-others__slider', {
        speed: 800,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        spaceBetween: 20,

        pagination: {
            el: '.category-others__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.category-others__button-next',
            prevEl: '.category-others__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
        },
    });
});


document.addEventListener('DOMContentLoaded', function () {
    const colorOptions = document.querySelectorAll('.category__card-color-option');
    const selectedColorInput = document.getElementById('selected-color');

    function getContrastColor(hexColor) {
        const r = parseInt(hexColor.substr(1, 2), 16);
        const g = parseInt(hexColor.substr(3, 2), 16);
        const b = parseInt(hexColor.substr(5, 2), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 128 ? '#ffffff' : '#ffffff';
    }

    document.querySelectorAll('.category__card').forEach(card => {
        const colorOptions = card.querySelectorAll('.category__card-color-option');
        const selectedColorInput = card.querySelector('.selected-color');

        colorOptions.forEach(option => {
            const bgColor = option.getAttribute('data-color');
            const borderColor = getContrastColor(bgColor);
            option.style.borderColor = borderColor;

            option.addEventListener('click', function () {
                colorOptions.forEach(opt => opt.classList.remove('selected'));

                this.classList.add('selected');

                selectedColorInput.value = this.getAttribute('data-color');

                const selectedBorderColor = getContrastColor(this.getAttribute('data-color'));
            });
        });

        const selectedOption = card.querySelector('.category__card-color-option.selected');
        if (selectedOption) {
            const selectedBorderColor = getContrastColor(selectedOption.getAttribute('data-color'));
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const colorOptions = document.querySelectorAll('.category__card-color-option');
    const selectedColorInput = document.getElementById('selected-color');

    function getContrastColor(hexColor) {
        const r = parseInt(hexColor.substr(1, 2), 16);
        const g = parseInt(hexColor.substr(3, 2), 16);
        const b = parseInt(hexColor.substr(5, 2), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 128 ? '#ffffff' : '#ffffff';
    }

    document.querySelectorAll('.product__right').forEach(card => {
        const colorOptions = card.querySelectorAll('.category__card-color-option');
        const selectedColorInput = card.querySelector('.selected-color');

        colorOptions.forEach(option => {
            const bgColor = option.getAttribute('data-color');
            const borderColor = getContrastColor(bgColor);
            option.style.borderColor = borderColor;

            option.addEventListener('click', function () {
                colorOptions.forEach(opt => opt.classList.remove('selected'));

                this.classList.add('selected');

                selectedColorInput.value = this.getAttribute('data-color');

                const selectedBorderColor = getContrastColor(this.getAttribute('data-color'));
            });
        });

        const selectedOption = card.querySelector('.category__card-color-option.selected');
        if (selectedOption) {
            const selectedBorderColor = getContrastColor(selectedOption.getAttribute('data-color'));
        }
    });
});


document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.advantages__slider', {
        speed: 800,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        spaceBetween: 20,

        pagination: {
            el: '.advantages__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.advantages__button-next',
            prevEl: '.advantages__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
        },
    });
});





document.addEventListener('DOMContentLoaded', function () {
    const gallerySwiper = new Swiper('.feedback__slider', {
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: {
            el: '.feedback__pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.feedback__button-next',
            prevEl: '.feedback__button-prev',
        },
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        // breakpoints: {
        //     640: {
        //         slidesPerView: 2,
        //     },
        //     1024: {
        //         slidesPerView: 3,
        //     },
        // }
    });

    const galleryModal = document.getElementById('galleryModal');
    const galleryModalMedia = document.getElementById('galleryModalMedia');
    const galleryCloseBtn = document.querySelector('.gallery-close-btn');
    const galleryPrevBtn = document.querySelector('.gallery-prev');
    const galleryNextBtn = document.querySelector('.gallery-next');

    // Получаем только слайды из нашей галереи
    const gallerySlides = Array.from(document.querySelectorAll('.swiper-gallery .swiper-slide.gallery'));
    let currentGalleryIndex = 0;

    // Открытие модального окна галереи
    function openGalleryModal(index) {
        currentGalleryIndex = index;
        const slide = gallerySlides[currentGalleryIndex];
        const type = slide.getAttribute('data-type');

        galleryModal.style.display = 'block';
        document.body.style.overflow = 'hidden';

        if (type === 'image') {
            galleryModalMedia.innerHTML = `<img src="${slide.getAttribute('data-src')}" alt="Увеличенное фото">`;
        } else if (type === 'video') {
            galleryModalMedia.innerHTML = `
                        <video class="gallery-modal-media" controls autoplay>
                            <source src="${slide.getAttribute('data-video-src')}" type="video/mp4">
                            Ваш браузер не поддерживает видео.
                        </video>
                    `;
        }
    }

    // Закрытие модального окна галереи
    function closeGalleryModal() {
        galleryModal.style.display = 'none';
        document.body.style.overflow = 'auto';

        // Останавливаем видео при закрытии
        const video = galleryModalMedia.querySelector('video');
        if (video) {
            video.pause();
        }
    }

    // Навигация по галерее
    function navigateGallery(direction) {
        if (direction === 'next') {
            currentGalleryIndex = (currentGalleryIndex + 1) % gallerySlides.length;
        } else {
            currentGalleryIndex = (currentGalleryIndex - 1 + gallerySlides.length) % gallerySlides.length;
        }

        openGalleryModal(currentGalleryIndex);
    }

    // Обработчики событий только для элементов галереи
    gallerySlides.forEach((slide, index) => {
        slide.addEventListener('click', () => openGalleryModal(index));
    });

    galleryCloseBtn.addEventListener('click', closeGalleryModal);
    galleryPrevBtn.addEventListener('click', () => navigateGallery('prev'));
    galleryNextBtn.addEventListener('click', () => navigateGallery('next'));

    // Закрытие по клику вне контента
    galleryModal.addEventListener('click', function (e) {
        if (e.target === galleryModal) {
            closeGalleryModal();
        }
    });

    // Закрытие по ESC
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeGalleryModal();
        } else if (e.key === 'ArrowLeft') {
            navigateGallery('prev');
        } else if (e.key === 'ArrowRight') {
            navigateGallery('next');
        }
    });
});



document.addEventListener('DOMContentLoaded', function () {
    const gallerySwiper = new Swiper('.product__feedback__slider', {
        slidesPerView: 1.7,
        spaceBetween: 20,
        watchOverflow: true,
        navigation: {
            nextEl: '.product__feedback__button-next',
            prevEl: '.product__feedback__button-prev',
        },
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        breakpoints: {
            640: { slidesPerView: 3 },
            1024: { slidesPerView: 6 },
        }
    });

    const galleryModal = document.getElementById('galleryModal');
    const galleryModalMedia = document.getElementById('galleryModalMedia');
    const galleryCloseBtn = document.querySelector('.feedback-close-btn');
    const galleryPrevBtn = document.querySelector('.gallery-prev');
    const galleryNextBtn = document.querySelector('.gallery-next');

    const gallerySlides = Array.from(document.querySelectorAll('.swiper-gallery .swiper-slide.gallery'));
    let currentGalleryIndex = 0;

    function openGalleryModal(index) {
        currentGalleryIndex = index;
        const slide = gallerySlides[currentGalleryIndex];
        const type = slide.getAttribute('data-type');
        galleryModal.style.display = 'block';
        document.body.style.overflow = 'hidden';

        if (type === 'image') {
            galleryModalMedia.innerHTML = `<img src="${slide.getAttribute('data-src')}" alt="Увеличенное фото">`;
        } else if (type === 'video') {
            const videoSrc = slide.getAttribute('data-video-src');
            const poster = slide.getAttribute('data-poster') || '';

            galleryModalMedia.innerHTML = `
                <div class="video-wrapper" style="position:relative; display:inline-block;">
                    <video class="gallery-modal-video" width="100%" height="auto" poster="${poster}"></video>
                    <button class="video-play-button" style="
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background: transparent;
                        border: none;
                        cursor: pointer;
                        z-index: 10;
                        width: 80px;
                        height: 80px;
                    ">
                        <span class="video-play-icon">
                            <svg class="circle">
                                <use href="img/sprite.svg#sprite--play-video" />
                            </svg>
                        </span>
                    </button>
                </div>
            `;

            const videoElement = galleryModalMedia.querySelector('video');
            const playButton = galleryModalMedia.querySelector('.video-play-button');

            videoElement.src = videoSrc;
            videoElement.preload = 'metadata';
            videoElement.controls = true;
            videoElement.autoplay = false;

            playButton.addEventListener('click', () => {
                videoElement.play();
                playButton.style.display = 'none';
            });

            videoElement.addEventListener('pause', () => {
                playButton.style.display = '';
            });
        }
    }

    function closeGalleryModal() {
        galleryModal.style.display = 'none';
        document.body.style.overflow = 'auto';

        const video = galleryModalMedia.querySelector('video');
        if (video) {
            video.pause();
            video.src = ''; // сброс src для выгрузки видео из памяти
        }
        galleryModalMedia.innerHTML = '';
    }

    function navigateGallery(direction) {
        if (direction === 'next') {
            currentGalleryIndex = (currentGalleryIndex + 1) % gallerySlides.length;
        } else {
            currentGalleryIndex = (currentGalleryIndex - 1 + gallerySlides.length) % gallerySlides.length;
        }
        openGalleryModal(currentGalleryIndex);
    }

    gallerySlides.forEach((slide, index) => {
        slide.addEventListener('click', () => openGalleryModal(index));
    });

    galleryCloseBtn.addEventListener('click', closeGalleryModal);
    galleryPrevBtn.addEventListener('click', () => navigateGallery('prev'));
    galleryNextBtn.addEventListener('click', () => navigateGallery('next'));

    galleryModal.addEventListener('click', (e) => {
        if (e.target === galleryModal) {
            closeGalleryModal();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeGalleryModal();
        } else if (e.key === 'ArrowLeft') {
            navigateGallery('prev');
        } else if (e.key === 'ArrowRight') {
            navigateGallery('next');
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const videoGallerySwiper = new Swiper('.swiper-video-gallery', {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
            nextEl: '.video-gallery-next',
            prevEl: '.video-gallery-prev',
        }
    });

    const videoGallerySlides = Array.from(document.querySelectorAll('.swiper-video-gallery .swiper-slide.gallery'));
    const videoGalleryModal = document.getElementById('videoGalleryModal');
    const videoGalleryModalMedia = document.getElementById('videoGalleryModalMedia');
    const videoGalleryCloseBtn = document.querySelector('.product-gallery-close-btn');

    let currentVideoIndex = 0;

    function openVideoGalleryModal(index) {
        currentVideoIndex = index;
        const slide = videoGallerySlides[currentVideoIndex];
        const videoSrc = slide.getAttribute('data-video-src');
        const poster = slide.getAttribute('data-poster') || '';

        videoGalleryModal.style.display = 'block';
        document.body.style.overflow = 'hidden';

        videoGalleryModalMedia.innerHTML = `
      <div class="video-wrapper" style="position: relative; display: inline-block;">
        <video class="modal-video" width="100%" height="auto" controls poster="${poster}">
          <source src="${videoSrc}" type="video/mp4" />
          Ваш браузер не поддерживает видео.
        </video>
        <button class="video-play-button" style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: transparent;
          border: none;
          cursor: pointer;
          z-index: 10;
          width: 80px;
          height: 80px;
        ">
          <span class="video-play-icon">
                            <svg class="circle">
                                <use href="img/sprite.svg#sprite--play-video" />
                            </svg>
           </span>
        </button>
      </div>
    `;

        const videoElement = videoGalleryModalMedia.querySelector('video');
        const playButton = videoGalleryModalMedia.querySelector('.video-play-button');

        videoElement.controls = true;
        videoElement.autoplay = false;

        playButton.addEventListener('click', () => {
            videoElement.play();
            playButton.style.display = 'none';
        }, { once: false });

        videoElement.addEventListener('pause', () => {
            playButton.style.display = '';
        });
    }

    function closeVideoGalleryModal() {
        videoGalleryModal.style.display = 'none';
        document.body.style.overflow = 'auto';
        const video = videoGalleryModalMedia.querySelector('video');
        if (video) {
            video.pause();
            video.src = '';
        }
        videoGalleryModalMedia.innerHTML = '';
    }

    const fullVideoBtn = document.querySelector('.product__right-review-button');
    if (fullVideoBtn) {
        fullVideoBtn.addEventListener('click', e => {
            e.preventDefault();
            openVideoGalleryModal(0);
        });
    }

    if (videoGalleryCloseBtn) {
        videoGalleryCloseBtn.addEventListener('click', closeVideoGalleryModal);
    } else {
        console.warn('Кнопка закрытия модального окна видеообзора не найдена!');
    }

    videoGalleryModal.addEventListener('click', e => {
        if (e.target === videoGalleryModal) closeVideoGalleryModal();
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeVideoGalleryModal();
    });
});


document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.product__others__slider', {
        speed: 800,
        mousewheel: true,
        watchOverflow: true,
        slidesPerView: 1.5,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true
        },
        spaceBetween: 20,

        pagination: {
            el: '.product__others__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.product__others__button-next',
            prevEl: '.product__others__button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
        },
    });
});


let lastScroll = 0;
const header = document.getElementById('header');

function checkScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    if (scrollPosition > 60) {
        header.classList.add('fixed');
        document.body.classList.add('has-fixed-header');
    } else {
        header.classList.remove('fixed');
        document.body.classList.remove('has-fixed-header');
    }

    lastScroll = scrollPosition;
    requestAnimationFrame(checkScroll);
}

checkScroll();

document.addEventListener('DOMContentLoaded', () => {
    const productWrapper = document.querySelector('.product__wrapper');
    if (!productWrapper) return;

    const colorOptions = productWrapper.querySelectorAll('.category__card-color-option');
    const imagesContainers = productWrapper.querySelectorAll('.product__left-images');

    const priceTextElem = productWrapper.querySelector('.product__right-price-text');
    const splitCheckbox = productWrapper.querySelector('#product-split');
    const splitPriceElem = productWrapper.querySelector('.product__right-split-price');
    const orderButtonPriceElem = productWrapper.querySelector('.product__right-split-button-price');

    function parsePrice(str) {
        return parseInt(str.replace(/\s/g, '').replace('₽', ''), 10);
    }
    function formatPrice(num) {
        return num.toLocaleString('ru-RU') + ' ₽';
    }

    function updateSplitAndPrice(price) {
        if (splitCheckbox && splitCheckbox.checked) {
            const half = Math.ceil(price / 2);
            splitPriceElem.textContent = `${formatPrice(half)} × 2`;
            orderButtonPriceElem.textContent = formatPrice(price);
        } else {
            const half = Math.ceil(price / 2);
            splitPriceElem.textContent = `${formatPrice(half)} × 2`;
            orderButtonPriceElem.textContent = formatPrice(price);
        }
    }

    // При смене цвета
    colorOptions.forEach(option => {
        option.addEventListener('click', () => {
            // Обновляем выделение цвета
            colorOptions.forEach(o => o.classList.remove('selected'));
            option.classList.add('selected');

            const selectedColor = option.getAttribute('data-color');

            // Показываем картинки с выбранным цветом
            imagesContainers.forEach(container => {
                if (container.getAttribute('data-color') === selectedColor) {
                    container.style.display = '';
                } else {
                    container.style.display = 'none';
                }
            });

            // Обновляем скрытый input
            const hiddenInput = productWrapper.querySelector('.selected-color, #selected-color');
            if (hiddenInput) hiddenInput.value = selectedColor;

            // Обновляем цену — Здесь предположим, что цена для каждого цвета фиксирована:
            // Для примера сделаем простую мапу цветов в цены:
            const pricesByColor = {
                '#2f317a': 8990,
                '#ce5099': 9490,
            };
            const newPrice = pricesByColor[selectedColor] || parsePrice(priceTextElem.textContent);

            priceTextElem.textContent = formatPrice(newPrice);
            updateSplitAndPrice(newPrice);
        });
    });

    // При переключении чекбокса сплита тоже обновляем цену
    if (splitCheckbox) {
        splitCheckbox.addEventListener('change', () => {
            const price = parsePrice(priceTextElem.textContent);
            updateSplitAndPrice(price);
        });
    }

    // Инициализируем отображение по умолчанию
    const initialSelected = productWrapper.querySelector('.category__card-color-option.selected');
    if (initialSelected) {
        initialSelected.click(); // Имитируем клик для инициализации
    }
});


document.addEventListener('DOMContentLoaded', () => {
    const burgerBtn = document.getElementById('burgerBtn');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileMenuCloseBtn = mobileMenu.querySelector('.mobile-menu-close');
    const submenuToggles = mobileMenu.querySelectorAll('.submenu-toggle');

    // Открытие/закрытие меню бургером
    burgerBtn.addEventListener('click', () => {
        const expanded = burgerBtn.getAttribute('aria-expanded') === 'true' || false;
        burgerBtn.setAttribute('aria-expanded', !expanded);
        burgerBtn.classList.toggle('active');
        mobileMenu.classList.toggle('active');
        mobileMenu.setAttribute('aria-hidden', expanded);
    });

    // Закрытие меню по кнопке
    if (mobileMenuCloseBtn) {
        mobileMenuCloseBtn.addEventListener('click', () => {
            burgerBtn.setAttribute('aria-expanded', false);
            burgerBtn.classList.remove('active');
            mobileMenu.classList.remove('active');
            mobileMenu.setAttribute('aria-hidden', true);

            // Закрываем все подменю
            submenuToggles.forEach(btn => {
                btn.setAttribute('aria-expanded', false);
                const submenu = document.getElementById(btn.getAttribute('aria-controls'));
                if (submenu) submenu.classList.remove('open');
            });
        });
    }

    // Плавное открытие/закрытие подменю
    submenuToggles.forEach(btn => {
        btn.addEventListener('click', () => {
            const expanded = btn.getAttribute('aria-expanded') === 'true' || false;
            btn.setAttribute('aria-expanded', !expanded);
            const submenu = document.getElementById(btn.getAttribute('aria-controls'));
            if (submenu) {
                if (expanded) {
                    submenu.classList.remove('open');
                } else {
                    submenu.classList.add('open');
                }
            }
        });
    });

    // Закрытие меню при клике вне меню
    document.addEventListener('click', (e) => {
        if (!mobileMenu.contains(e.target) && !burgerBtn.contains(e.target)) {
            burgerBtn.setAttribute('aria-expanded', false);
            burgerBtn.classList.remove('active');
            mobileMenu.classList.remove('active');
            mobileMenu.setAttribute('aria-hidden', true);
            submenuToggles.forEach(btn => {
                btn.setAttribute('aria-expanded', false);
                const submenu = document.getElementById(btn.getAttribute('aria-controls'));
                if (submenu) submenu.classList.remove('open');
            });
        }
    });
    const menuLinks = mobileMenu.querySelectorAll('a');

    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            // Закрываем меню
            burgerBtn.setAttribute('aria-expanded', false);
            burgerBtn.classList.remove('active');
            mobileMenu.classList.remove('active');
            mobileMenu.setAttribute('aria-hidden', true);

            // Закрываем подменю
            submenuToggles.forEach(btn => {
                btn.setAttribute('aria-expanded', false);
                const submenu = document.getElementById(btn.getAttribute('aria-controls'));
                if (submenu) submenu.classList.remove('open');
            });
        });
    });
});